(function() {
  function initializeCarousel(carousel) {
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';
    
    const track = carousel.querySelector('.carousel-block-track');
    const slides = Array.from(track.children);
    const prevBtn = carousel.querySelector('.carousel-block-prev');
    const nextBtn = carousel.querySelector('.carousel-block-next');
    const dotsContainer = carousel.querySelector('.carousel-block-dots');
    
    if (slides.length === 0) return;
    
    let currentIndex = 0;
    let autoplayInterval;
    
    // Crear dots
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('carousel-block-dot');
        if (index === 0) dot.classList.add('active');
        dot.setAttribute('aria-label', 'Ir a diapositiva ' + (index + 1));
        dot.addEventListener('click', () => {
          goToSlide(index);
          resetAutoplay();
        });
        dotsContainer.appendChild(dot);
      });
    }
    
    const dots = dotsContainer ? Array.from(dotsContainer.children) : [];
    
    function updateCarousel() {
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    }
    
    function goToSlide(index) {
      currentIndex = index;
      updateCarousel();
    }
    
    function nextSlide() {
      currentIndex = (currentIndex + 1) % slides.length;
      updateCarousel();
    }
    
    function prevSlide() {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      updateCarousel();
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        resetAutoplay();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        resetAutoplay();
      });
    }
    
    function startAutoplay() {
      if (slides.length > 1) {
        autoplayInterval = setInterval(nextSlide, 5000);
      }
    }
    
    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }
    
    startAutoplay();
    
    carousel.addEventListener('mouseenter', () => {
      clearInterval(autoplayInterval);
    });
    
    carousel.addEventListener('mouseleave', () => {
      startAutoplay();
    });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-carousel-block]').forEach(initializeCarousel);
  });
  
  document.addEventListener('shopify:section:load', function(event) {
    const carousel = event.target.querySelector('[data-carousel-block]');
    if (carousel) {
      carousel.dataset.initialized = '';
      initializeCarousel(carousel);
    }
  });
})();